window.dynamicHeader = function () {
    return {
        hidden: false,
        lastScroll: window.scrollY,
        scrollUpDelta: 0,
        stickyLimit: 500,
        thresholdUp: 200,
        init() {
            window.addEventListener('scroll', () => {
                const current = window.scrollY;
                const delta = current - this.lastScroll;

                if (current <= this.stickyLimit) {
                    this.hidden = false;
                } else {
                    if (delta > 0) {
                        // Down
                        this.scrollUpDelta = 0;
                        this.hidden = true;
                    } else {
                        // Up
                        this.scrollUpDelta += Math.abs(delta);
                        if (this.scrollUpDelta >= this.thresholdUp) {
                            this.hidden = false;
                        }
                    }
                }

                this.lastScroll = current;
            });
        },
    };
}
